import { createStyles, UnstyledButton } from '@tf/ui';
import { fmt } from '@tf/utils';
import { forwardRef } from 'react';

const useStyles = createStyles(() => {
	return {
		button: {
			fontWeight: 500,
			borderBottom: '1px dotted',
			whiteSpace: 'nowrap',
		},
		value: {
			fontWeight: 500,
		},
	};
});

interface Props {
	value: string | undefined;
	onClick?: () => void;
	style?: React.CSSProperties;
	defaultValue?: string;
	raw?: boolean;
}

export const DateValue = forwardRef<any, Props>(({ value, style, defaultValue = 'N/A', onClick, raw = false }, ref) => {
	const displayValue = raw ? value || defaultValue : value ? fmt.toDate(value, { preset: 'full_date' }) : defaultValue;

	const { classes } = useStyles();

	return onClick ? (
		<UnstyledButton style={style} ref={ref} className={classes.button} onClick={onClick}>
			{displayValue}
		</UnstyledButton>
	) : (
		<span ref={ref} style={style} className={classes.value}>
			{displayValue}
		</span>
	);
});
